<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="`Delete Account -- ${user}`"
    :reset-modal="resetModal"
    :submit-button-text="'DELETE'"
    :submit-modal="deleteAccount"
  >
    <b-row>
      <b-col>
        <p>
          This action will delete all account information for
          {{ user }}. Please be absolutely certain you want to do this before
          proceeding, as this action cannot be undone.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p v-if="deleteAccountError">
          An error occurred deleting the specified account. You might have an
          expired token or insufficient permissions to perform this action
        </p>
      </b-col>
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import AccountRestService from "../../services/rest/services/AccountRestService";

export default {
  name: "DeleteAccountModal",
  components: { TsnyModal },
  props: {
    user: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "deleteAccountModal",
      deleteAccountError: null
    };
  },
  methods: {
    deleteAccount: function(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this;
      $comp.deleteAccountError = false;

      return AccountRestService.deleteAccount($comp.user)
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
          $comp.$router.replace({ name: "UserAdministration" });
        })
        .catch(err => {
          console.error(err);
          $comp.deleteAccountError = true;
        });
    },
    resetModal: function() {
      this.deleteAccountError = null;
    }
  }
};
</script>

<style scoped></style>
